import {Component, OnInit} from '@angular/core';
import {GlobalDataService} from "./core/services/global.data.service";
import {SecurityService} from "./core/services/security.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'iturriapp';

  constructor(private globalDataService: GlobalDataService, private securityService: SecurityService) {}

  async ngOnInit() {
    if (await this.securityService.existeSesion() === true) {
      await this.globalDataService._init();
    }
  }
}
